import { createRole, updateRole, getAllRoles, deleteRole } from "../../../services/stockJournal/roles";

export default {
    namespaced: true,
    state: {
        roles: [],
    },
    getters: {
        roles(state) {
            return state.roles;
        },
        getRoleById: state => id => state.roles.find(each => each.id == id)
    },
    mutations: {
        setRoles(state, payload) {
            state.roles = payload;
        },
        addRole(state, payload) {
            state.roles = [...state.roles, payload];
        },
        updateRole(state, payload) {
            let roles = [...state.roles];
            let index = roles.indexOf(roles.find(each => each.id == payload.id));
            roles[index] = payload;
            state.roles = roles;
        },
        removeRole(state, payload) {
            let roles = [...state.roles];
            let index = roles.indexOf(roles.find(each => each.id == payload.id));
            roles.splice(index, 1);
            state.roles = roles;
        }
    },
    actions: {
        fetchRoles({commit}) {
            return new Promise((resolve, reject) => {
                getAllRoles()
                    .then(response => {
                        commit("setRoles", response.data);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            })
        },
        storeRole({commit}, payload) {
            return new Promise((resolve, reject) => {
                createRole(payload)
                    .then(response => {
                        commit("addRole", response.data.record);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        EditRole(context, payload) {
            return new Promise((resolve, reject) => {
                updateRole(payload)
                    .then(response => {
                        context.commit("updateRole", response.data.record);
                        resolve(response);
                    }).catch(error => {
                        reject(error)
                    });
            });
        },
        removeRole(context, payload) {
            return new Promise((resolve, reject) => {
                deleteRole(payload)
                    .then(response => {
                        context.commit("removeRole", response.data.record);
                        resolve(response);
                    }).catch(error => reject(error));
            });
        }
    }
}